import { jsx } from 'react/jsx-runtime';
import { composeEventHandlers } from '@radix-ui/primitive';
import { CommandInput } from 'cmdk';
import { forwardRef } from 'react';
import { useSingleSelectContext } from '../../contexts/context.mjs';

const SingleSelectSearch = forwardRef(({ onValueChange, ...props }, forwardedRef) => {
  const { searchKeyword, onSearchKeywordChange } = useSingleSelectContext("Search");
  const handleValueChange = composeEventHandlers(
    onValueChange,
    onSearchKeywordChange
  );
  return /* @__PURE__ */ jsx(
    CommandInput,
    {
      "data-scope": "single-select",
      "data-part": "search",
      value: searchKeyword,
      onValueChange: handleValueChange,
      ref: forwardedRef,
      ...props
    }
  );
});

export { SingleSelectSearch as SelectSearch };
//# sourceMappingURL=Search.mjs.map
